import React from "react";

function FamilyMemberIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M32 0C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8C0 3.58172 3.58172 0 8 0H32Z"
        fill="url(#paint0_linear_1383_2186)"
      />
      <path
        d="M32 0C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8C0 3.58172 3.58172 0 8 0H32Z"
        stroke="#E5E7EB"
      />
      <path
        d="M20 20C21.0609 20 22.0783 19.5786 22.8284 18.8284C23.5786 18.0783 24 17.0609 24 16C24 14.9391 23.5786 13.9217 22.8284 13.1716C22.0783 12.4214 21.0609 12 20 12C18.9391 12 17.9217 12.4214 17.1716 13.1716C16.4214 13.9217 16 14.9391 16 16C16 17.0609 16.4214 18.0783 17.1716 18.8284C17.9217 19.5786 18.9391 20 20 20ZM18.5719 21.5C15.4938 21.5 13 23.9937 13 27.0719C13 27.5844 13.4156 28 13.9281 28H26.0719C26.5844 28 27 27.5844 27 27.0719C27 23.9937 24.5063 21.5 21.4281 21.5H18.5719Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1383_2186"
          x1="0"
          y1="20"
          x2="40"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2563EB" />
          <stop offset="1" stop-color="#7C3AED" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default FamilyMemberIcon;
